'use client'

import { SmartHeader } from '@/widgets/smart-header'
import { Footer } from '@/widgets/footer'
import { CellForm } from '@/widgets/cell-form'

// Metadata moved to layout or separate metadata file

export default function SellOOOMoscowPage() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <SmartHeader />
      <main className="flex-1 pt-14">
        {/* Hero секция */}
        <section className="container py-12 md:py-20">
          <div className="mx-auto max-w-4xl text-center">
            <h1 className="mb-6 text-3xl md:text-5xl font-bold">Продать ООО в Москве</h1>
            <p className="mb-8 text-xl text-muted-foreground">
              Выгодная альтернатива ликвидации в Москве. Продайте свое ООО быстро и безопасно с
              полным юридическим сопровождением.
            </p>
            <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground mb-8">
              <div className="flex items-center gap-2">
                <span className="text-orange-500">✓</span>
                <span>Быстрее ликвидации в 10 раз</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-orange-500">✓</span>
                <span>Получите деньги вместо трат</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-orange-500">✓</span>
                <span>Работаем в Москве с 2016 года</span>
              </div>
            </div>
          </div>
        </section>

        {/* Преимущества в Москве */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-6xl">
            <h2 className="mb-12 text-2xl md:text-3xl font-bold text-center">
              Почему в Москве выгодно продавать ООО
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏢</span>
                </div>
                <h3 className="font-semibold mb-3">Высокий спрос</h3>
                <p className="text-sm text-muted-foreground">
                  В Москве постоянно высокий спрос на готовые ООО для бизнеса
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💰</span>
                </div>
                <h3 className="font-semibold mb-3">Лучшие цены</h3>
                <p className="text-sm text-muted-foreground">
                  Московские ООО стоят дороже региональных на 30-50%
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">⚡</span>
                </div>
                <h3 className="font-semibold mb-3">Быстрая сделка</h3>
                <p className="text-sm text-muted-foreground">
                  Оформление в Москве за 1-2 дня против 6+ месяцев ликвидации
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🤝</span>
                </div>
                <h3 className="font-semibold mb-3">Очные встречи</h3>
                <p className="text-sm text-muted-foreground">
                  Личные встречи в офисе в Москве для максимальной безопасности
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Ценник по Москве */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-12 text-2xl md:text-3xl font-bold text-center">
              Средние цены на ООО в Москве
            </h2>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg p-6 text-center">
                <h3 className="text-lg font-semibold mb-2">Чистое ООО</h3>
                <div className="text-2xl font-bold text-orange-600 mb-2">50-80 тыс. ₽</div>
                <p className="text-sm text-muted-foreground">
                  Возраст 1-3 года, без оборотов, московская регистрация
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 text-center border-2 border-orange-200">
                <div className="bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded mb-2 inline-block">
                  Популярно
                </div>
                <h3 className="text-lg font-semibold mb-2">С оборотами</h3>
                <div className="text-2xl font-bold text-orange-600 mb-2">150-300 тыс. ₽</div>
                <p className="text-sm text-muted-foreground">
                  История операций, банковские счета, кредитная история
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 text-center">
                <h3 className="text-lg font-semibold mb-2">С лицензиями</h3>
                <div className="text-2xl font-bold text-orange-600 mb-2">300-500 тыс. ₽</div>
                <p className="text-sm text-muted-foreground">
                  Лицензии, СРО допуски, специальные разрешения
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Процесс в Москве */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-12 text-2xl md:text-3xl font-bold text-center">
              Как продать ООО в Москве
            </h2>

            <div className="space-y-8">
              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Заявка и встреча</h3>
                  <p className="text-muted-foreground">
                    Оставьте заявку с информацией о вашем ООО. Встретимся в офисе в Москве для
                    обсуждения деталей и оценки.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Проверка документов</h3>
                  <p className="text-muted-foreground">
                    Анализ документов, налоговой и судебной истории в московских реестрах.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Оценка и предложение</h3>
                  <p className="text-muted-foreground">
                    Определяем рыночную стоимость для Москвы, учитывая специфику региона и
                    конкуренцию.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Сделка в Москве</h3>
                  <p className="text-muted-foreground">
                    Подписание договора в московском офисе, нотариальное заверение, регистрация
                    смены собственника. Получение оплаты.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Форма заявки */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-2xl">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">Продать ООО в Москве</h2>
              <p className="text-muted-foreground">
                Оставьте заявку — проведем бесплатную оценку вашего ООО с учетом московских цен
              </p>
            </div>
            <CellForm />
          </div>
        </section>

        {/* Контакты */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-8 text-2xl md:text-3xl font-bold text-center">Наш офис в Москве</h2>

            <div className="bg-white rounded-lg p-8 text-center">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="font-semibold mb-4">Адрес офиса</h3>
                  <p className="text-muted-foreground mb-2">г. Москва, ул. Тверская, д. 1</p>
                  <p className="text-sm text-muted-foreground">м. Охотный ряд, Театральная</p>
                </div>

                <div>
                  <h3 className="font-semibold mb-4">Контакты</h3>
                  <p className="text-muted-foreground mb-2">
                    <a href="tel:+79254040999" className="hover:text-orange-500">
                      +7 (925) 404-09-99
                    </a>
                  </p>
                  <p className="text-sm text-muted-foreground">Ежедневно с 9:00 до 19:00</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
